export default "__VITE_ASSET__IHE_wzh7__"